import React from 'react';
import HeroSection from '../../components/HeroSection/HeroSection';
import MissionSection from '../../components/MissionSection/MissionSection';
import EnergyProjectsMap from '../../components/EnergyProjectsMap/EnergyProjectsMap';
import KeyStatistics from '../../components/KeyStatistics/KeyStatistics';
import EnergyFinancingTrends from '../../components/EnergyFinancingTrends/EnergyFinancingTrends';
import ProjectImpactOverview from '../../components/ProjectImpactOverview/ProjectImpactOverview';
import StoriesFromField from '../../components/StoriesFromField/StoriesFromField';
import KeyStatisticsSimple from '../../components/KeyStatisticsSimple/KeyStatisticsSimple';
import SustainableImpactSnapshots from '../../components/SustainableImpactSnapshots/SustainableImpactSnapshots';
import AboutEnergyTracker from '../../components/AboutEnergyTracker/AboutEnergyTracker';
import BannerSlider from '../../components/BannerSlider/BannerSlider';
import PartnersCollaborations from '../../components/PartnersCollaborations/PartnersCollaborations';
import './HomePageV1.scss';

const HomePageV1 = () => {
  return (
    <div className="home-page-v1">
      <BannerSlider />
      <MissionSection />
      <EnergyProjectsMap />
      <KeyStatisticsSimple />
      <EnergyFinancingTrends />
      <ProjectImpactOverview />
      <StoriesFromField />
      <SustainableImpactSnapshots />
      <AboutEnergyTracker />
      <PartnersCollaborations />
    </div>
  );
};

export default HomePageV1;
